import React, { useState, useEffect, useContext } from "react";
import Button from "../Button/Button";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Layout from "../Layout/Layout";
import PageHeader from "../PageHeader/PageHeader";
import PageTransition from "../PageTransition/PageTransition";
import Progress from "../../stacks/progress/ProgressAWS";
import ReactS3Uploader from "react-s3-uploader";
import companies from "../../stacks/company/DxCompanyAWS";
import styled from "styled-components";
import { Block } from "../../styles/commons";
import { ProgressesStatus } from "../../context";
import { Table } from "reactstrap";
import { useErrorToast } from "../../hooks/useErrorToast";

const UploadScreen = (props) => {
  const { setErrorMsg, errorToast } = useErrorToast("");
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [completing, setCompleting] = useState(false);

  const api = companies.getInstance();

  const progress = useContext(ProgressesStatus);

  useEffect(() => {
    async function getList() {
      try {
        const list = await api.listUpload();
        setFileList(list);
        setLoading(false);
        // setText(`${JSON.stringify(list, null, 2)}`)
      } catch (err) {
        setErrorMsg(err.message);
        setLoading(false);
      }
    }

    getList();
  }, [api, setErrorMsg]);

  async function getURL(fileName) {
    try {
      const url = await api.retrieveUploadURL(fileName);
      return url;
    } catch (err) {
      setErrorMsg(err.message);
      setLoading(false);
      throw err;
    }
  }

  async function getSignedURL(file, callback) {
    try {
      const signedUrl = await getURL(file.name);
      callback({ signedUrl });
    } catch (err) {
      setErrorMsg(err.message);
      setLoading(false);
      console.log(`ERROR getSignedURL ${err.message}`);
    }
  }

  async function getList() {
    try {
      setErrorMsg("");
      setLoading(true);
      const list = await api.listUpload();
      setFileList(list);
      setLoading(false);
      // setText(`${JSON.stringify(list, null, 2)}`)
    } catch (err) {
      setErrorMsg(err.message);
      setLoading(false);
    }
  }

  function onProgress(value) {
    if (value === 0) {
      setErrorMsg("");
      setLoading(true);
    }
  }

  function onError(message, value, xml) {
    setErrorMsg(message);
    console.error(`UploadScreen onError ${JSON.stringify(arguments)}`);
  }

  function onFinish(value) {
    getList();
    setLoading(false);
  }

  async function complete() {
    try {
      const progressApi = Progress.getInstance();
      const data = await progressApi.store({ uploadFiles: "available" });
      progress.update(data.progresses);
      props.history.push("/progress");
    } catch (err) {
      setErrorMsg(`Upload complete error: ${JSON.stringify(err, null, 2)}`);
      console.error(`Upload complete error: ${JSON.stringify(err, null, 2)}`);
    }
  }

  return (
    <Layout product="ica">
      <PageHeader title="Optional Upload">
        <div style={{textAlign: 'right'}}>
        {progress && progress.questionnaire === "unavailable" && (
          <Button small color="#28b536" click={() => setCompleting(true)}>
            COMPLETE
          </Button>
        )}
        </div>
      </PageHeader>
      <Wrapper>
        <Instructions>
          Provide additional information to amplify your situation:
          {/* Provide additional information to amplify your debriefing appointment
          with a Senior Consultant of the Dream Exchange: */}
          <p/>
          <ol>
            <li>Business Plan</li>
            <li>Marketing Plan</li>
            <li>Investment Documents (i.e., a PPM)</li>
          </ol>
        </Instructions>
      </Wrapper>

      <PageTransition loading={loading} msg="...">
        <ReactS3Uploader
          getSignedUrl={getSignedURL}
          onProgress={onProgress}
          onError={onError}
          onFinish={onFinish}
          uploadRequestHeaders={{}}
          value=""
        />
      </PageTransition>
      <Block>
        <Table striped size="small">
          <thead>
            <tr>
              <th>File</th>
              <th>Upload Date and Time</th>
              <th>Size</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {fileList.map((item) => {
              const dateTime = new Date(item.lastModified);
              return (
                <tr key={item.fileName}>
                  <td>{item.fileName}</td>
                  <td>{dateTime.toLocaleString()}</td>
                  <td>{item.size}</td>
                  {/* <td><Button small>Download</Button></td> */}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Block>
      {/* <textarea rows={25} cols={132} value={text} readOnly/> */}
      {errorToast}
      {completing && (
        <ConfirmationModal
          cancel={() => setCompleting(false)}
          confirm={() => complete()}
          confirmationBtnTitle="COMPLETE"
        >
          {`You may come back to UPLOAD at any time to upload files..`}
        </ConfirmationModal>
      )}
    </Layout>
  );
};

const Instructions = styled.div`
  color: #333;
  font-weight: 500;
  display: inline-block;
  vertical-align: top;
`;

const Wrapper = styled.div`
  margin: 0px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export default UploadScreen;
